import { ImageObject, Organization, PostalAddress, WithContext } from 'schema-dts';

import configs from '@/configs';

export const organizationJSONLD = (): WithContext<Organization> => ({
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Общество с ограниченной ответственностью «Агентство Региональных Перевозок»',
  telephone: '+7 (495) 970-17-17',
  address: 'г. Москва, Хорошевское шоссе, 32А',
  image: configs.baseLogo,
  url: 'https://www.aviakassa.com',
  legalName: 'Общество с ограниченной ответственностью «Агентство Региональных Перевозок»',
  email: 'info@aviakassa.com',
  sameAs: ['https://t.me/aviakassa_com', 'https://dzen.ru/aviakassa']
});

export const imageObjectJSONLD = (): WithContext<ImageObject> => ({
  '@context': 'https://schema.org',
  '@type': 'ImageObject',
  url: configs.baseLogo,
  contentUrl: configs.baseLogo,
  width: '56',
  height: '56'
});

export const postalAdressJSONLD = (): WithContext<PostalAddress> => ({
  '@context': 'https://schema.org',
  '@type': 'PostalAddress',
  streetAddress: 'Хорошевское шоссе, 32А',
  addressLocality: 'Москва',
  postalCode: '123007',
  addressCountry: 'RU'
});
